import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import EsignFlowDrawer from 'components/Flows/EsignFlows/Drawer/Drawer';
import EsignFlow from 'components/Flows/EsignFlows/EsignFlows';
import EsignAnalysisDrawer from 'components/Analyses/EsignAnalyses/Drawer/Drawer';

const EsignFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <EsignAnalysisDrawer />
      <EsignFlowDrawer />
      <EsignFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <EsignFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);